module.exports = __webpack_public_path__ + "static/media/why-soc-md-mk-stat-3.a2fb3c93.png";